import { Injectable } from '@angular/core';
import { CHAT_HISTORY_KEY, chatHistory, CURRENT_CHAT_SESSION_ID } from '../../../digital-assistant.model';

@Injectable()
export class ChatConversationHistoryService {
  constructor() {}

  createConversationHistory(response: Record<string, any>, chatHistory: chatHistory[]): void {
    const storedSessionId = localStorage.getItem(CURRENT_CHAT_SESSION_ID);
    const currentSession = chatHistory.find(session => session.sessionId === storedSessionId);
    const conversationHistory = currentSession?.conversation_history || [];

    if (response !== null && response.conversation && response?.generated_snowflake_query?.length) {
      const conversation = response.conversation?.present_conversation;
      const userMessage = this._processUserMessage(conversation, conversationHistory.length + 1);
      const aiMessages = this._processGeneratedSnowflakeQuery(
        response.generated_snowflake_query,
        conversationHistory.length + 1
      );
      conversationHistory.push([userMessage, aiMessages]);
      localStorage.setItem(CHAT_HISTORY_KEY, JSON.stringify(chatHistory));
    }
  }

  private _processUserMessage(data: Record<string, any>[], index: number): Record<string, any> | null {
    const userInput = data.find(item => item?.user_input)?.user_input;
    if (userInput) {
      return {
        content: userInput,
        role: 'Human Message',
        message_index: index,
      };
    }
    return null;
  }

  private _processGeneratedSnowflakeQuery(data: string[], index): Record<string, any> {
    const mappedData = {
      content: data,
      role: 'AI Message',
      message_index: index,
    };
    return mappedData;
  }
}
